import React, { useEffect, useMemo, useState } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody } from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchQualifications,
  createQualification,
} from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Swal from 'sweetalert2';
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Qualifications = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const { qualifications, loading, success, error } = useSelector((state) => state.QualificationMaster || {});
  const [authDetails, setAuthDetails] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  // useEffect(() => {
  //     if (loading) {
  //       dispatch(fetchQualifications(authDetails?.unit_id));
  //     }
  //   }, [loading, authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchQualifications(unitId));
  }, [dispatch]);


  // const columns = useMemo(() => [
  //   {
  //     Header: "Action",
  //           className: "serial-no",
  //     applyHeaderClass: true,
  //     Cell: (cellProps) => {
  //       return (
  //         <div className="d-flex gap-3">
  //           <Link
  //             to="#"
  //             className="text-success"
  //             onClick={() => handleEdit(cellProps.row.original)}
  //           >
  //             <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //             <UncontrolledTooltip placement="top" target="edittooltip">
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "S.No",
  //     Cell: ({ row }) => qualifications.length - row.index,
  //           className: "serial-no",
  //     applyHeaderClass: true,
  //   },
  //   {
  //     Header: "Qualification",
  //     accessor: "Qualific_Name",
  //   },
  //   {
  //     Header: "Description",
  //     accessor: "Quali_Desc",
  //   },
  //   {
  //     Header: "Created By",
  //     accessor: "created_by",
  //   },
  //   {
  //     Header: "Created On",
  //     accessor: "created_dt",
  //   },
    
  // ], [qualifications]);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: "S.No",
        Cell: ({ row }) => qualifications.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      {
        Header: "Qualification",
        accessor: "Qualific_Name",
      },
      {
        Header: "Description",
        accessor: "Quali_Desc",
      },
      {
        Header: "Created By",
        accessor: "created_by",
      },
      {
        Header: "Created On",
        accessor: "created_dt",
      },
    ];

    // 👉 If canEdit true → add Action column
    if (canEdit) {
      baseColumns.unshift({
        Header: "Action",
        className: "serial-no",
        applyHeaderClass: true,
        Cell: (cellProps) => {
          const id = `edittooltip-${cellProps.row.index}`;

          return (
            <div className="d-flex gap-3">
              {canEdit && (
                <button
                  type="button"
                  className="text-success bg-transparent border-0 p-0"
                  onClick={() => handleEdit(cellProps.row.original)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bx bxs-edit font-size-18" id={id} />
                </button>
              )}

              {/* {canDelete && (
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  handleToggleStatus(cellProps.row.original);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            )} */}
            </div>
          );
        },
      });
    }

    return baseColumns;
  }, [qualifications, canEdit]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Quali_id: 0,
      qualification: "",
      description: "",
      createdby: authDetails?.user_id,
      unit_id: authDetails?.unit_id,
    },
    validationSchema: Yup.object({
      qualification: Yup.string()
        .required("Please Enter Qualification Name")
        .max(45, "Qualification Name must not exceed 45 characters")
        .matches(
          /^[a-zA-Z0-9 ]+$/,
          "Qualification Name allows only alphabets, numbers and spaces"
        ),

      description: Yup.string()
        .required("Please Enter Description")
        .max(100, "Description must not exceed 100 characters")
        .matches(
          /^[a-zA-Z0-9 ]+$/,
          "Description contains invalid characters"
        ),
    }),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("Quali_id", values.Quali_id);
      formData.append("Qualific_Name", values.qualification);
      formData.append("Quali_Desc", values.description);
      formData.append("created_by", values.createdby);
      formData.append("unit_id", values.unit_id);

      dispatch(createQualification(formData));
      setIsEdit(false);

      formik.resetForm();
    },
  });

  const handleEdit = (row) => {
    formik.setValues({
      Quali_id: row.Quali_id,
      qualification: row.Qualific_Name,
      description: row.Quali_Desc,
      createdby: authDetails?.user_id,
      unit_id: authDetails?.unit_id,
    });
    setIsEdit(true);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Setup" breadcrumbItem="Qualifications" />

          <Row>
            <Col lg="12">
              {(canCreate || canEdit) && (
              <Card>                
                <CardBody>
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col md={4} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="qualification">
                            Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="qualification"
                            name="qualification"
                            type="text"
                            maxLength={45}
                            value={formik.values.qualification}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.qualification && formik.errors.qualification}
                          />
                          {formik.touched.qualification && formik.errors.qualification ? (
                            <div className="text-danger">{formik.errors.qualification}</div>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={4} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="description">
                            Description <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="description"
                            name="description"
                            type="text"
                            maxLength={100}
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.description && formik.errors.description}
                          />
                          {formik.touched.description && formik.errors.description ? (
                            <div className="text-danger">{formik.errors.description}</div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md={4} sm={12} className="d-flex justify-content-end align-items-center">
                        <div className="d-flex  justify-content-end align-items-center">
                          <Button type="submit" color="primary" className="btn button-save me-2">
                            <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                          </Button>
                          <Button type="button" color="secondary"
                            onClick={() => {
                              formik.resetForm();
                              setIsEdit(false);
                            }}
                            className="btn button-cancel">
                            <i className="fas fa-sync me-1" /> Cancel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
                )}
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={qualifications && qualifications.length > 0 ? qualifications : []}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>


  );
};

export default Qualifications;
